// frontend/src/components/layout/Navbar.js
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import SimpleClock from '../common/SimpleClock';
import EmergencyStopButton from '../common/EmergencyStopButton';

function parseCsv(value) {
  return String(value || '')
    .split(',')
    .map((v) => v.trim())
    .filter(Boolean);
}

function canUseEmergencyStop(user) {
  if (!user) return false;

  const allowedRoles = parseCsv(
    process.env.REACT_APP_EMERGENCY_ALLOWED_ROLES || 'admin,developer'
  );
  const allowedUsernames = parseCsv(
    process.env.REACT_APP_EMERGENCY_ALLOWED_USERNAMES || ''
  );

  return (
    allowedRoles.includes(user.role) || allowedUsernames.includes(user.username)
  );
}

export default function Navbar() {
  const { user, logout } = useAuth();

  return (
    <nav className="flex items-center px-2 py-2 bg-neutral-100 border-b border-neutral-200">
      {/* 인증 링크 */}
      {user ? (
        <>
          <Link
            to="/"
            target="_blank"
            className="ml-4 mr-6 no-underline hover:underline text-neutral-800"
          >
            유저 차트
          </Link>
          <Link
            to="/ls-overseas-account"
            target="_blank"
            className="mr-6 no-underline hover:underline"
          >
            계좌현황
          </Link>

          {/* 로그인된 유저명 표시 */}
          {user.role === 'admin' ? (
            <>
              <Link
                to="/admin/admin-chart"
                target="_blank"
                className="mr-6 no-underline hover:underline"
              >
                관리자 차트
              </Link>
              <Link
                to="/admin/sim-chart"
                target="_blank"
                className="mr-6 no-underline hover:underline"
              >
                시뮬레이션 차트
              </Link>
              <Link
                to="/admin/top-volume-tables"
                target="_blank"
                className="mr-6 no-underline hover:underline"
              >
                시간대별 체결량
              </Link>
              <Link
                to="/admin/boxline-input"
                target="_blank"
                className="mr-6 no-underline hover:underline"
              >
                박스라인 입력
              </Link>
              {/* <Link
                to="/admin/manage-manual-boxlines"
                target="_blank"
                className="mr-6 no-underline hover:underline"
              >
                박스라인 관리
              </Link> */}
              <Link
                to="/admin/memo-input"
                target="_blank"
                className="mr-6 no-underline hover:underline"
              >
                알림 메모 입력
              </Link>
              <Link
                to="/admin/calendar-input"
                target="_blank"
                className="mr-6 no-underline hover:underline"
              >
                일정 입력
              </Link>
              <Link
                to="/admin/detail-history"
                target="_black"
                className="mr-6 no-underline hover:underline"
              >
                일별 거래 히스토리
              </Link>
            </>
          ) : (
            // 개발자 전용
            user.role == 'developer' && (
              <>
                <Link
                  to="/developer/sim-chart"
                  target="_blank"
                  className="mr-6 no-underline hover:underline"
                >
                  시뮬레이션 차트
                </Link>
                <Link
                  to="/developer/admin-chart"
                  target="_blank"
                  className="mr-6 no-underline hover:underline"
                >
                  관리자 차트
                </Link>
                <Link
                  to="/developer/top-volume-tables"
                  target="_blank"
                  className="mr-6 no-underline hover:underline"
                >
                  시간대별 체결량
                </Link>
                <Link
                  to="/developer/boxline-input"
                  target="_blank"
                  className="mr-6 no-underline hover:underline"
                >
                  박스라인 입력
                </Link>
                <Link
                  to="/developer/manage-manual-boxlines"
                  target="_blank"
                  className="mr-6 no-underline hover:underline"
                >
                  박스라인 관리
                </Link>
                <Link
                  to="/developer/memo-input"
                  target="_blank"
                  className="mr-6 no-underline hover:underline"
                >
                  알림 메모 입력
                </Link>
                <Link
                  to="/developer/calendar-input"
                  target="_blank"
                  className="mr-6 no-underline hover:underline"
                >
                  일정 입력
                </Link>
                <Link
                  to="/developer/detail-history"
                  target="_black"
                  className="mr-6 no-underline hover:underline"
                >
                  일별 거래 히스토리
                </Link>
                <Link
                  to="/developer/ls-overseas-account"
                  target="_blank"
                  className="mr-6 no-underline hover:underline"
                >
                  계좌현황 Dev
                </Link>
              </>
            )
          )}

          <span className="mr-4 text-neutral-700">👤 {user.username}님</span>
          <button
            onClick={() => {
              logout();
              alert('로그아웃 되었습니다.');
            }}
            className="inline-flex items-center justify-center rounded-md
                     bg-neutral-200 px-3 py-1 text-neutral-800
                     hover:bg-neutral-300 focus:outline-none focus:ring-2 focus:ring-sky-500"
          >
            로그아웃
          </button>

          {/* 시계를 맨 오른쪽으로 밀기 */}
          <div className="ml-auto flex items-center pr-8">
            <SimpleClock />
            {canUseEmergencyStop(user) && (
              <div className="ml-2 mr-3">
                <EmergencyStopButton />
              </div>
            )}
          </div>
        </>
      ) : (
        <>
          <Link to="/signup" className="mr-4 no-underline hover:underline">
            회원가입
          </Link>
          <Link to="/login" className="no-underline hover:underline">
            로그인
          </Link>
        </>
      )}
    </nav>
  );
}
